import React from 'react';
import { StyleSheet, Text, View, type StyleProp, type ViewStyle } from 'react-native';

const DAY = 24 * 60 * 60 * 1000;

interface Props {
	oldestDueOn?: number;
	balanceCents: number;
	asOf?: number;
	compact?: boolean;
	style?: StyleProp<ViewStyle>;
}

const tone = (days: number): { bg: string; fg: string } => {
	if (days <= 30) return { bg: '#fff8e1', fg: '#ef6c00' };
	if (days <= 60) return { bg: '#ffe0b2', fg: '#e65100' };
	if (days <= 90) return { bg: '#ffccbc', fg: '#bf360c' };
	return { bg: '#ffebee', fg: '#b71c1c' };
};

export const DaysOverdueBadge: React.FC<Props> = ({ oldestDueOn, balanceCents, asOf, compact, style }) => {
	if (!oldestDueOn || balanceCents <= 0) return null;
	const days = Math.floor(((asOf ?? Date.now()) - oldestDueOn) / DAY);
	if (days <= 0) return null;
	const t = tone(days);
	return (
		<View style={[styles.badge, { backgroundColor: t.bg }, compact && styles.compact, style]}>
			<Text style={[styles.label, { color: t.fg }, compact && styles.labelCompact]}>
				{days} {days === 1 ? 'day' : 'days'} overdue
			</Text>
		</View>
	);
};

const styles = StyleSheet.create({
	badge: {
		alignSelf: 'flex-start',
		paddingHorizontal: 8, paddingVertical: 3, borderRadius: 10,
	},
	compact: { paddingHorizontal: 6, paddingVertical: 2, borderRadius: 8 },
	label: { fontSize: 12, fontWeight: '600' },
	labelCompact: { fontSize: 11 },
});
